import { AllMetrics } from '@app/core/models/metrics.constants';

export class SetChartMetrics {
  static type = '[Chart Metrics] Set Metrics';

  constructor(readonly metrics: AllMetrics[]) {}
}
